import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import Styles from '../IntegrationInitializationModal.module.scss'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { GoogleDrive } from 'blaze-ui/icons'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const GoogleDriveNotice = () => (
  <IntegrationNotice
    message={
      <div className={Styles.message}>
        Authorize Blaze to access your Google Drive.
        <div className={Styles.note}>
          We'll import documents, images, and brand assets to help build your brand kit.
        </div>
      </div>
    }
  />
)

const GoogleDriveInitialization = ({ useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const sharedProps = {
    notice: <GoogleDriveNotice />,
    providerName: 'Google Drive',
    onClose: closeModal,
    icon: <GoogleDrive size={32} />,
    title: 'Connect Google Drive Account',
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.GoogleDrive),
    primaryButtonText: 'Connect Google Drive',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default GoogleDriveInitialization
